import { render } from "./App.vue?vue&type=template&id=4443b1bc&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4443b1bc&lang=scss"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__